class ProductGallery extends Carousel {
  constructor() {
    super();
    this.paneContainerWrapper = document.querySelector('.zoom-in-feature-wrapper');
    this.paneContainerWrapper.style.display = "hidden";
    this.paneContainer = document.querySelector('.zoom-in-feature');
    // Only for desktop
    if (window.innerWidth > 750) {
      this.initiateZoom();
      this.adjustZoomFeature();
      window.addEventListener("resize", this.adjustZoomFeature.bind(this));
      window.addEventListener("scroll", this.handleScroll.bind(this));
    }
    
    this.variantFilter = this.carouselElement.dataset['variantfilter'] === 'true' || false;
  }

  initiateZoom() {
    if (!Drift) return;

    const driftImgs = this.carouselElement.querySelectorAll('.slot-item img[data-zoom]');
    const paneContainer = document.querySelector('.zoom-in-feature');

    driftImgs.forEach(img => {
      new Drift(img, {
        zoomFactor: 2.2,
        paneContainer: paneContainer,
        inlinePane: false,
        hoverBoundingBox: true,
        showWhitespaceAtEdges: true,
      });

      // Show zoom pane & change cursor on hover
      img.addEventListener("mouseenter", () => {
        this.paneContainerWrapper.style.display = "block";
        img.style.cursor = "crosshair";
      });

      img.addEventListener("mouseleave", () => {
        this.paneContainerWrapper.style.display = "none";
        img.style.cursor = "default"; // Revert cursor to normal
      });
    });
  }

  handleScroll() {
    if (this.scrollTimeout) return;

    this.scrollTimeout = requestAnimationFrame(() => {
      this.adjustZoomFeature();
      this.scrollTimeout = null;
    });
  }

  adjustZoomFeature() {
    const zoomFeature = document.querySelector('.zoom-in-feature');
    const announcementBar = document.querySelector('.announcement-bar-section');
    const sectionHeader = document.querySelector('.section-header');
    const atcContainer = document.querySelector('.durex__sticky__atc__container') || document.querySelector('.out__of__stock__atc__container') ;
    
    if (!zoomFeature || !atcContainer) return;

    // Check if elements are in viewport
    const announcementVisible = this.isElementInViewport(announcementBar);
    const headerVisible = this.isElementInViewport(sectionHeader);

    let announcementHeight = (announcementVisible && announcementBar) ? announcementBar.offsetHeight : 0;
    let headerHeight = (headerVisible && sectionHeader) ? sectionHeader.offsetHeight : 0;
    let atcHeight = atcContainer.offsetHeight || 0;

    let totalExcludedHeight = announcementHeight + headerHeight + atcHeight +10;

    // Smooth transition for height changes
    zoomFeature.style.transition = "height 0.3s ease-out";
    zoomFeature.style.height = `${window.innerHeight - totalExcludedHeight - 10}px`;

    // Position just above the .durex__sticky__atc__container
    zoomFeature.style.bottom = `${atcHeight + 10}px`;
    zoomFeature.style.position = 'fixed';
  }

  isElementInViewport(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0; // Checks if the element is visible in the viewport
  }

  showAllMedia() {
    let allItems = this.carouselElement.querySelectorAll('[data-filter]');
    let allThumbnailItems = this.syncElement.querySelectorAll('[data-filter]');

    allItems.forEach(element => {
      element.classList.add('splide__slide');
      element.classList.remove('hidden');
    });

    allThumbnailItems.forEach(element => {
      element.classList.add('splide__slide');
      element.classList.remove('hidden');
    });

    this.refreshSlider();
  }

  filterMedia(media) {
    this.showAllMedia();

    let filterSlides = this.carouselElement.querySelectorAll( `[data-filter]:not([data-filter="${media?.alt}"])` );
    let filterSlidesThumbnails = this.syncElement.querySelectorAll( `[data-filter]:not([data-filter="${media?.alt}"])` );

    filterSlides.forEach(element => {
      element.classList.remove('splide__slide');
      element.classList.add('hidden');
    });

    filterSlidesThumbnails.forEach(element => {
      element.classList.remove('splide__slide');
      element.classList.add('hidden');
    });
    this.refreshSlider();
  }

  setActiveMedia(media) {
    if(this.variantFilter && media?.alt){
      this.filterMedia(media);
    }

    let Slides = this.carousel.Components.Slides.filter( `li[data-media-id="${media?.id}"]:not(.splide__slide--clone)` );
    if ( Slides[ 0 ] ) {
      this.refreshSlider();
      this.carousel.go( Slides[ 0 ].index );
    }
  }
}

customElements.define('product-gallery', ProductGallery);
